import { render, staticRenderFns } from "./DetailEntrance.vue?vue&type=template&id=0972cf42&scoped=true&lang=pug&"
import script from "./DetailEntrance.vue?vue&type=script&lang=js&"
export * from "./DetailEntrance.vue?vue&type=script&lang=js&"
import style0 from "./DetailEntrance.vue?vue&type=style&index=0&id=0972cf42&prod&lang=sass&scoped=true&"
import style1 from "./DetailEntrance.vue?vue&type=style&index=1&id=0972cf42&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0972cf42",
  null
  
)

export default component.exports